import { Upload } from '@/components/icons'
import { PrntrCard, PrntrInput } from './prntr-input'

interface UploadFileRowProps {
  /** Opens the caller's hidden file input. */
  onSelect: () => void
  disabled?: boolean
  error?: string
  /** Row label — override when the surrounding copy needs to differ. */
  label?: string
}

/**
 * Compact "pick a file" row for the document drawers, in place of the old
 * 135px upload box. Keeps the Upload glyph rather than a camera: these accept
 * any file type, not just images.
 */
export function UploadFileRow({
  onSelect,
  disabled,
  error,
  label = 'Upload file',
}: UploadFileRowProps) {
  return (
    <PrntrCard className={disabled ? 'pointer-events-none opacity-50' : undefined}>
      <PrntrInput
        label={label}
        onClick={disabled ? undefined : onSelect}
        error={error}
        iconRight={
          <button
            type="button"
            aria-label={label}
            className="flex items-center"
            disabled={disabled}
            onClick={(e) => {
              e.stopPropagation()
              onSelect()
            }}
          >
            <Upload />
          </button>
        }
      >
        {null}
      </PrntrInput>
    </PrntrCard>
  )
}
